/**
 * Blog subscribe forms — handles both the newsletter band ([data-newsletter])
 * and inline lead-capture shortcodes ([data-lead-capture]).
 * Both require data-subscribe-url on the form element.
 * Optional data-event-name overrides the default Brevo event name.
 */
var ERROR_MESSAGES = {
    invalid_email:  'Please enter a valid email address.',
    invalid_domain: 'This email domain does not exist. Please check the address.',
    already_subscribed: 'You are already subscribed.',
    default:        'Something went wrong. Please try again.',
};

function showError($form, code) {
    var $err = $form.find('[data-subscribe-error]');
    $err.text(ERROR_MESSAGES[code] || ERROR_MESSAGES.default).show();
}

function initForm($, $form) {
    var url       = $form.data('subscribe-url');
    var eventName = $form.data('event-name') || '';

    $form.on('submit', function (e) {
        e.preventDefault();

        var email = $form.find('[name="email"]').val().trim();
        if (!email) { return; }

        var parts  = email.split('@');
        var domain = parts.length === 2 ? parts[1] : '';
        if (parts.length !== 2 || !domain.includes('.') || domain.startsWith('.') || domain.endsWith('.')) {
            showError($form, 'invalid_email');
            return;
        }

        var $btn = $form.find('[type="submit"]');
        $btn.prop('disabled', true);
        $form.find('[data-subscribe-error]').hide();

        var payload = { email: email };
        if (eventName) { payload.event_name = eventName; }

        $.ajax({
            url         : url,
            method      : 'POST',
            contentType : 'application/json',
            data        : JSON.stringify(payload),
            success: function (res) {
                if (res.success) {
                    $form.hide();
                    $form.siblings('[data-subscribe-success]').show();
                } else {
                    showError($form, res.error);
                    $btn.prop('disabled', false);
                }
            },
            error: function (xhr) {
                var res = xhr.responseJSON || {};
                showError($form, res.error);
                $btn.prop('disabled', false);
            }
        });
    });
}

function init($) {
    $('[data-newsletter], [data-lead-capture]').each(function () {
        initForm($, $(this));
    });
}

module.exports = { init };
